import React from 'react';
import Icon from '../../common/icons';
import Card, { Threshold } from './Card';
import { HTMLSectionWithLink } from './elements/Link';

export default ({ offer }) => (
  <Card
    offer={offer}
    image={<Icon name={offer.icon} />}
    originalPrice={offer.original_price}
  >
    <Threshold offer={offer}>
      {({ passed }) => {
        if (passed) {
          const subtitle_over_threshold = (
            offer.subtitle_over_threshold || 'free DISPLAYNAME'
          ).replace('DISPLAYNAME', offer.display_name);
          return (
            <HTMLSectionWithLink>{subtitle_over_threshold}</HTMLSectionWithLink>
          );
        }
        const subtitle_under_threshold = (
          offer.subtitle_under_threshold || 'to get a free DISPLAYNAME'
        ).replace('DISPLAYNAME', offer.display_name);
        return (
          <HTMLSectionWithLink>{subtitle_under_threshold}</HTMLSectionWithLink>
        );
      }}
    </Threshold>
  </Card>
);
